import { DateTime } from "luxon";

export default function formatDateTimezone(date) {
  const userTimeZone = DateTime.local().zoneName;

  return DateTime.fromISO(date, {
    zone: "utc",
  }).setZone(userTimeZone);
}
